<template>
	<div>
		<div>
			<vs-chip v-if="this.order.order.type === 1 && this.product.fulfilment_method === 'FBR'">
				<vx-tooltip text="Fulfillment door verkoper" position="top">
					FBR
				</vx-tooltip>
			</vs-chip>

			<vs-chip v-if="this.order.order.type === 1 && this.product.fulfilment_method === 'FBB'">
				<vx-tooltip text="Fulfillment door bol.com" position="top">
					FBB
				</vx-tooltip>
			</vs-chip>
		</div>

		<div>
			<vs-chip v-if="this.order.order.type === 1 && this.product.fulfilment_distribution_party === 1">
				<vx-tooltip text="Verzenden via verkoper" position="top">
					VVV
				</vx-tooltip>
			</vs-chip>

			<vs-chip v-if="this.order.order.type === 1 && this.product.fulfilment_distribution_party === 2">
				<vx-tooltip text="Verzenden via bol.com" position="top">
					VVB
				</vx-tooltip>
			</vs-chip>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		order: {
			type: Object,
			required: true
		},
		product: {
			type: Object,
			required: true,
		}
	}
}
</script>
